import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import { UserContext } from '../../../context/UserContext';
import { AuthContext } from '../../../context/AuthContext';
import { MascotaForm } from '../../../components/Mascotas/MascotaForm';
import { Loader } from '../../../components/ui/Loader';
import { ExpedienteAzulFooter } from '../../../components/ui/ExpedienteAzulFooter';

export const RegistrarAdopcion = () => {
    
    const { languaje } = useContext(UserContext);
    const { isLoading } = useContext(AuthContext);

    const usuario_dueño = localStorage.getItem('CA_usuario');
    const rol = JSON.parse(usuario_dueño!);
    debugger
    const dueno_mascota = rol.nombre;

    return (
        <>
            <div className='mascotas__container mb-0'>
                <div className="mascotas__header">
                    <h3>{ languaje === 'ES' ? 'Registrar Mascota para Adopción' : 'Register Pet to Adoption' }</h3>
                    <Link to="/mascotas/adopcion" className="btn btn-callejeritos">{ languaje === 'ES' ? 'REGRESAR' : 'BACK' }</Link>
                </div>
                <div className="mascotas__body">
                    <MascotaForm mascota={ null } dueno={ rol } scope='adopcion' modificar={true}/>
                </div>
                <div className="mascotas__footer mb-2">
                    <ExpedienteAzulFooter/>
                </div>
            </div>
            { isLoading && <Loader/>}
        </>
    )
}
